export default {
  IRR: 'IRR',
  IRT: 'IRT'
}
